import { formatMoney } from '@betterment/js-runtime';
import { Separator } from '@betterment/samba-react';
import { ActivityDrawerLayout } from '@betterment/shared-components/src/components/activity/components/drawer/common/ActivityDrawerLayout';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';

import { ActivityItemFragment } from '../../../../graphql/fragments/activityItem.generated';
import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';

export const AdvisoryFee: React.FC<{
  item: NarrowTypename<ActivityItemFragment, 'ActivityItemFee'>;
}> = ({ item }) => (
  <ActivityDrawerLayout title="Advisory Fee">
    <DrawerListRow label="Account" value={item.subAccount.envelope.purpose?.name ?? ''} />
    <Separator />
    <DrawerListRow label="Amount" value={item.amount ? formatMoney(item.amount) : ''} />
    <Separator />
  </ActivityDrawerLayout>
);
